export const mapGameName = gameName => {
  switch (gameName) {
    case "leagueoflegends":
      return "League of Legends"
    case "teamfight-tactics":
      return "Teamfight Tactics"
    case "fortnite":
      return "Fortnite"
    case "overwatch":
      return "Overwatch"
    case "csgo":
      return "CS GO"
    case "dota":
      return "Dota"
    case "dota2":
      return "Dota 2"
    case "super-smash-bros-ultimate":
      return "Super Smash Bros. Ultimate"
    case "wow":
      return "World of Warcraft"
    case "hearthstone":
      return "Hearthstone"
    case "magic-the-gathering":
      return "Magic: The Gathering"
    case "valorant":
      return "VALORANT"
    default:
      return "Motivation"
  }
}



// WEBPACK FOOTER //
// ./src/constants/liveClass.js